import { Action } from '@ngrx/store';
import { ServiceTypeModel } from './model';

export enum ActionTypes {
  FAILURE = '[ServiceType] Failure',

  LOAD_REQUEST = '[ServiceType] Load Request',
  LOAD_SUCCESS = '[ServiceType] Load Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}
export class LoadRequestAction implements Action {
  readonly type = ActionTypes.LOAD_REQUEST;
}

export class LoadSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_SUCCESS;
  constructor(public items: ServiceTypeModel[]) {}
}

export type Actions = FailureAction | LoadRequestAction | LoadSuccessAction;
